import { EPageType } from 'shared/models/page-type';
import { EKeywordSource } from '.';

export interface IPageTraffic {
  canonicalUrl: string;
  pageType: EPageType;
  seoPageId: string;
  currentPid?: string;
}

export interface IFeedPageTraffic extends IPageTraffic {
  pageType: EPageType.feed;
  categoryId: string;
}

export interface IHashtagPageTraffic extends IPageTraffic {
  pageType: EPageType.hashtag;
  hashtagId: string;
}

export interface IArticlePageTraffic extends IPageTraffic {
  pageType: EPageType.article;
  groupId: string;
  mediaId: string;
  contentByTranslate: 0 | 1;
}

export interface IVideoPageTraffic extends IPageTraffic {
  pageType: EPageType.video;
  groupId: string;
  mediaId: string;
  contentByTranslate: 0 | 1;
}

export interface IPOIPageTraffic extends IPageTraffic {
  pageType: EPageType.poi;
  poiId: string;
}

export interface IDiscoverPageTraffic extends IPageTraffic {
  pageType: EPageType.discover;
  keyword: string;
  standardKeyword: string;
  hasBreadCrumb: boolean;
}

export interface IExperiencePageTraffic extends IPageTraffic {
  pageType: EPageType.experience | EPageType.experience_article | EPageType.experience_ugc;
  keyword: string;
  hasGPTAnswer: boolean;
  standardKeyword: string;
  question: string;
  keywordSource: EKeywordSource;
}

export interface IUserPageTraffic extends IPageTraffic {
  pageType: EPageType.user;
  userLinkName: string;
  userId: string;
}

export interface IUserFollowPageTraffic extends IPageTraffic {
  pageType: EPageType.user_follow;
  userLinkName: string;
  userId: string;
}

export interface IUserTopicPageTraffic extends IPageTraffic {
  pageType: EPageType.user_topic;
  userLinkName: string;
  userId: string;
}

export interface ISearchSugPageTraffic extends IPageTraffic {
  pageType: EPageType.search_sug;
}

export type PageLevelTraffic =
  | IFeedPageTraffic
  | IHashtagPageTraffic
  | IPOIPageTraffic
  | IArticlePageTraffic
  | IVideoPageTraffic
  | IDiscoverPageTraffic
  | IExperiencePageTraffic
  | IUserPageTraffic
  | IUserFollowPageTraffic
  | IUserTopicPageTraffic
  | ISearchSugPageTraffic;

export const PageLevelTrafficUtil = {
  getPageIdFromTraffic: (traffic: PageLevelTraffic): string | null => {
    if (traffic.pageType === EPageType.feed) {
      return traffic.categoryId;
    }

    if (traffic.pageType === EPageType.hashtag) {
      return traffic.hashtagId;
    }

    if (traffic.pageType === EPageType.poi) {
      return traffic.poiId;
    }

    if (traffic.pageType === EPageType.article || traffic.pageType === EPageType.video) {
      return traffic.groupId;
    }

    if (traffic.pageType === EPageType.discover) {
      return traffic.keyword;
    }

    if (
      traffic.pageType === EPageType.experience ||
      traffic.pageType === EPageType.experience_article ||
      traffic.pageType === EPageType.experience_ugc
    ) {
      return traffic.keyword;
    }

    if (
      traffic.pageType === EPageType.user ||
      traffic.pageType === EPageType.user_follow ||
      traffic.pageType === EPageType.user_topic
    ) {
      return traffic.userId;
    }

    return null;
  },
};
